import React from 'react';
import { useDataAttrs } from 'Helpers/Testing';
import { FDSlider } from '@facet-wealth/design';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';

export const Slider = (props) => {
  const {
    alignSelf,
    disabled,
    flex,
    flexGrow,
    flexShrink,
    label,
    max,
    min,
    name,
    onChange,
    value,
    valueLabelDisplay,
    ...rest
  } = props;
  const dataAttrs = useDataAttrs(rest);

  if (value === undefined || value === null) {
    return null;
  }

  return (
    <FDSlider
      {...dataAttrs}
      alignSelf={alignSelf}
      disabled={disabled}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      label={label}
      max={max}
      min={min}
      name={name}
      onChange={onChange}
      value={value === '' ? undefined : +value}
      valueLabelDisplay={valueLabelDisplay}
    />
  );
};

Slider.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  max: inputDefaultProps.max,
  min: inputDefaultProps.min,
  name: inputDefaultProps.name,
  onChange: inputDefaultProps.onChange,
  value: inputDefaultProps.value,
  valueLabelDisplay: inputDefaultProps.valueLabelDisplay,
};

Slider.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: inputPropTypes.label.isRequired,
  max: inputPropTypes.max,
  min: inputPropTypes.min,
  name: inputPropTypes.name,
  onChange: inputPropTypes.onChange,
  value: inputPropTypes.value,
  valueLabelDisplay: inputPropTypes.valueLabelDisplay,
};
